module.exports = __webpack_public_path__ + "static/media/collaborators.aed6882a.svg";